import { site } from "@/mocks/site";

export default function Methodology() {
  return (
    <div className="grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 md:grid-cols-2">
      {site.principles.map((item, index) => (
        <div key={item.title} className="flex items-start gap-4 bg-background-50 p-5 md:p-7">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
            <i className={`${item.icon} text-[22px]`} aria-hidden="true"></i>
          </span>
          <div>
            <div className="flex items-center gap-2">
              <span className="font-label text-[11px] text-foreground-400">{String(index + 1).padStart(2, "0")}</span>
              <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
            </div>
            <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
}